import numerics from './numerics';

export default {
  methods: {
    $formatNumber(number, format) {
      return numerics.format(number, format);
    },
    $unformatNumber(input, lang) {
      return numerics.unformat(input, lang);
    },
  },
};
